import { createRoutes, str, bool } from '../typesafe-routes';

export const studentRoutes = createRoutes({
  index: { path: [] },

  accountSetting: { path: ['account-setting'] },

  assessment: {
    path: ['assessment'],
    children: {
      legacy: { path: [str('assessmentReportId')] },
      new: {
        path: ['n', str('assessmentReportId')],
      },
    },
  },

  auth: {
    path: ['auth'],
    children: {
      etoos: { path: ['etoos', str('token')] },
      megastudy: { path: ['megastudy', str('token')] },
      token: { path: ['token', str('token')] },
    },
  },

  event: {
    path: ['event'],
    children: {
      friendsRecommend: { path: ['friends-recommend'] },
      parentsInvitation: { path: ['parents-invitation'] },
    },
  },

  experience: { path: ['experience', str('metaContentModuleId')] },

  grammar: { path: ['grammar'] },

  handwritingNote: {
    path: ['handwriting-note', str('studyActivityInstanceId')],
  },

  levelReport: {
    path: ['level-report', str('reportId')],
  },

  login: { path: ['login'] },

  maintenance: { path: ['maintenance'] },

  mildangAiLogs: {
    path: ['mildang-ai-logs', str('studentId')],
  },

  monthlyReports: {
    path: ['monthly-reports', str('subject'), str('reportId')],
  },

  myGroup: { path: ['my-group', str('groupId')] },

  myLearningStatus: {
    path: ['my-learning-status', str('groupId')],
    children: {
      detail: { path: ['detail', str('curriculumId')] },
    },
  },

  myNote: { path: ['my-note'] },

  privacy: {
    path: ['privacy'],
    children: {
      v20220902: { path: ['20220902'] },
      v20250611: { path: ['20250611'] },
    },
  },

  report: { path: ['report'] },
  signup: { path: ['signup'] },

  study: {
    path: ['study-module', str('studyModuleInstanceId'), str('unitId')],
    query: [str.optional('todayMissionDate'), bool.optional('shouldAnswerBeRevealed')],
    children: {
      summary: { path: ['summary'] },
      studyActivity: {
        path: [str('studyActivityId')],
        children: {
          result: { path: ['result'] },
        },
      },
    },
  },
  terms: {
    path: ['terms'],
    children: {
      v20220902: { path: ['20220902'] },
      old: { path: ['old'] },
    },
  },
  todayMission: { path: ['today-mission'] },
  videoPlayTest: { path: ['video-play-test'] },
  weeklyReports: {
    path: ['weekly-reports', str('reportId')],
    children: {
      detail: { path: ['detail', str('userId'), str('dueDate')] },
    },
  },

  api: {
    path: ['api'],
    children: {
      version: { path: ['version'] },
    },
  },
});
